// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var OkSign = function OkSign(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M8 .748A7.252 7.252 0 1015.252 8 7.252 7.252 0 008 .748zM6.643 11.8L3.491 8.652l1.167-1.168 1.985 1.985L11.2 4.915l1.168 1.168z"
    }))
  );
};

export default OkSign;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/OkSign.js
// module id = 1034
// module chunks = 0